export class DynamicReportModel {
    keyword   = '';
    test   = false;
    clinic_id = 0;
    from_date = '';
    to_date = '';
}